import firebase from 'firebase';
import { createStore, applyMiddleware, compose } from 'redux';
import { reactReduxFirebase } from 'react-redux-firebase';
import thunk from 'redux-thunk';

import reducer from './reducers';

const config = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DB_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_SENDER_ID,
};

firebase.initializeApp(config);

// initialize firestore
// firebase.firestore() // <- needed if using firestore

const rrfConfig = { products: 'products' };

const createStoreWithFirebase = compose(
  reactReduxFirebase(firebase, rrfConfig),
  // reduxFirestore(firebase) // <- needed if using firestore
)(createStore);

/* eslint-disable no-underscore-dangle */
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
/* eslint-enable */

const configureStore = () =>
  createStoreWithFirebase(
    reducer,
    composeEnhancers(applyMiddleware(thunk)),
  );

export default configureStore;



// WEBPACK FOOTER //
// ./src/store/index.js